
let mattress = [
    {
        name: "Hal Kitzmiller Signature",
        price: ["$899.00", "$1,099.00", "$1,599.00", "$1,799.00"],
        size: ["Twin", "Double", "Queen", "King"],
        image: "https://www.jarrodyellets.com/images/lumbar/mat5.png",
        description: "Designed by Hal himself, the Hal Kitzmiller Signature mattress will perfectly conform to you back shape.  This mattress is perfect for people who spend all day sitting on park benches.  Guaranteed not to smell like the East River.",
        id: "kitz",
        index: 0
    },
    {
        name: "Druidia Air",
        price: ["$499.00", "$599.00", "$799.00", "$999.00"],
        size: ["Twin", "Double", "Queen", "King"],
        image: "https://www.jarrodyellets.com/images/lumbar/mat1.png",
        description: "Filled with air from Planet Drudidia, the Drudidia Air Mattress is the envy of the galaxy.  The mattress comes with a 1 year protection guarentee from Lone Star.",
        id: "air",
        index: 1
    },
    {
        name: "Kramerica Sand",
        price: ["$799.00", "$999.00", "$1,299.00", "$1,599.00"],
        size: ["Twin", "Double", "Queen", "King"],
        image: "https://www.jarrodyellets.com/images/lumbar/mat6.png",
        description: "Ever dream of sleeping on the beach every night?  Now you can with the Kramerica Sand Mattress.  Filled with original Coney Island sand.",
        id: "kram",
        index: 2
    },
    {
        name: "NextGen Memory Foam",
        price: ["$1,399.00", "$1,699.00", "$1,999.00", "$2,199.00"],
        size: ["Twin", "Double", "Queen", "King"],
        image: "https://www.jarrodyellets.com/images/lumbar/mat3large.png",
        description: "Developed by NASA, the NextGen Memory Foam Mattress will remember the contours of up to 6 people.  Supporting app is available via Android or iPhone.",
        id: "next",
        index: 3
    },
    {
        name: "Lumbar Yard Classic",
        price: ["$399.00", "$499.00", "$699.00", "$999.00"],
        size: ["Twin", "Double", "Queen", "King"],
        image: "https://www.jarrodyellets.com/images/lumbar/mat2.png",
        description: "First mattress ever designed by the Lumbar Yard.  Built with a mix of foam, latex, and springs, this mattress will fit most sleeping needs.",
        id: "lumb",
        index: 4
    },
    {
        name: "Faux Feather",
        price: ["$1,199.00", "$1,599.00", "$1,899.00", "$1,999.00"],
        size: ["Twin", "Double", "Queen", "King"],
        image: "https://www.jarrodyellets.com/images/lumbar/mat4.png",
        description: "Made with synthetic feathers, the vegan friendly Faux Feather Mattress is the perfect mattress for cold climates.",
        id: "feat",
        index: 5
    }
    ]
    
    export default mattress;